import Vue from 'vue'
import App from './App.vue'

import router from './router'

import request from './utils/request.js'


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

//全局样式
import "../src/assets/css/base.css";
import "../src/assets/css/m.css";

import store from './store'; // 引入我们前面导出的store对象

import './api'

Vue.config.productionTip = false
// import axios from 'axios'
// import VueAxios from 'vue-axios'
// Vue.use(VueAxios,axios)

Vue.use(ElementUI);

new Vue({
    router,
	store,
    data:{
        minWith: 960, //小屏幕宽度
        isMinScreen: false,
        isLoadMobileCss: false
    },
    methods: {
        //检测是否是小屏幕
        checkMinScreen(){
            return document.body.clientWidth <= this.minWith
        },
    },
    mounted (){
        if (this.checkMinScreen()) {
            this.isMinScreen = true
        }
        // 监听窗口大小
        window.onresize = () => {
            if (document.body.clientWidth < this.minWith) {
                this.isMinScreen = true
            } else {
                this.isMinScreen = false
            }
        }
    },
    render: h => h(App),
}).$mount('#app')
